<template>
  <div v-if="loading_page === true">
    <v-sheet
      :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`"
      class="pa-3"
    >
      <v-skeleton-loader type="article, actions"></v-skeleton-loader>
    </v-sheet>
  </div>
  <div class="mt-1" v-else>
    <v-row>
      <v-col xs="12" sm="12" md="6" lg="8" xl="8" cols="12">
        <div class="title_page ma-3">
          <h4 class="breadcrumb_title_page">โอนสินค้า</h4>
          <v-breadcrumbs :items="sub_menu">
            <template v-slot:divider>
              <v-icon>mdi-chevron-right</v-icon>
            </template>
          </v-breadcrumbs>
        </div>
      </v-col>
    </v-row>
    <div class="mt-1">
      <v-card class="mb-5" elevation="4" style="border-radius: 15px">
        <v-card-text>
          <div class="mt-3 pa-4">
            <v-form ref="form" @submit.prevent="addProductTransferStore()">
              <v-row>
                <!-- ข้อมูลทั่วไป -->
                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                  <div class="d-flex">
                    <div class="title_form_main">
                      <div class="logo_timeline">
                        <img src="@/assets/arin_assets/ordericon.png" />
                      </div>
                    </div>
                    <div class="header-content py-1 pl-5 pr-5 text-center">
                      <div class="content-font">
                        ข้อมูลสาขาที่ต้องการโอนสินค้า
                      </div>
                    </div>
                  </div>
                </v-col>
                <v-col
                  xs="6"
                  sm="6"
                  md="6"
                  lg="6"
                  xl="6"
                  cols="6"
                  class="ml-5 pl-5"
                >
                  <v-form-group>
                    <label class="label_form_text"
                      >สาขา <span class="required--text">*</span></label
                    >

                    <v-autocomplete
                      class="input-radius"
                      color="#D6BFAF"
                      :items="branch_option"
                      item-text="owner_name"
                      item-value="customer_code"
                      v-model="branch_select"
                      placeholder="กรุณาเลือกสาขาที่ต้องการโอนสินค้า"
                      :rules="[(v) => !!v || 'กรุณากรอกข้อมูล']"
                      outlined
                      dense
                    ></v-autocomplete>
                  </v-form-group>
                </v-col>
              </v-row>
              <v-row>
                <!-- ข้อมูลทั่วไป -->
                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                  <div class="d-flex">
                    <div class="title_form_main">
                      <div class="logo_timeline">
                        <img src="@/assets/arin_assets/cycle.png" />
                      </div>
                    </div>
                    <div class="header-content py-1 pl-5 pr-5 text-center">
                      <div class="content-font">รายการสินค้า</div>
                    </div>
                  </div>
                </v-col>
                <v-col
                  xs="12"
                  sm="12"
                  md="12"
                  lg="12"
                  xl="12"
                  cols="12"
                  class="ml-5 px-5"
                >
                  <v-form-group>
                    <label class="label_form_text"
                      >สินค้า <span class="required--text">*</span></label
                    >
                    <v-autocomplete
                      class="input-radius"
                      color="#D6BFAF"
                      v-model="productSelect"
                      :items="productList"
                      item-text="name"
                      item-value="id"
                      :rules="[(v) => !!v || 'กรุณากรอกข้อมูล']"
                      @change="addProductToTable"
                      placeholder="กรุณาเลือกสินค้า"
                      hide-details="auto"
                      outlined
                      dense
                    ></v-autocomplete>
                  </v-form-group>
                </v-col>
                <v-col
                  xs="12"
                  sm="12"
                  md="12"
                  lg="12"
                  xl="12"
                  cols="12"
                  class="ml-5 px-5"
                >
                  <v-simple-table>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th width="150" class="text-left">ลำดับ</th>
                          <th width="150" class="text-left">รหัสสินค้า</th>
                          <th class="text-left">ชื่อสินค้า</th>
                          <th class="text-left">ชื่อทางแพทย์</th>
                          <th width="180" class="text-left">จำนวนในคลัง</th>
                          <th width="180" class="text-left">
                            จำนวนโอน <span class="required--text">*</span>
                          </th>
                          <th width="100" class="text-left">ลบ</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(item, index) in productTable"
                          :key="item.id"
                        >
                          <td>{{ index + 1 }}</td>
                          <td>{{ item.product_code }}</td>
                          <td>{{ item.name }}</td>
                          <td>{{ item.name_sci }}</td>
                          <td>{{ item.in_stock }}</td>
                          <td>
                            <v-text-field
                              elevation="4"
                              class="input-radius my-2"
                              v-model="item.qty"
                              :rules="[
                                (v) =>
                                  validateQty() ||
                                  'กรุณาอย่าใส่จำนวนเกิน',
                                (v) => !!v || 'กรุณากรอกข้อมูล',
                              ]"
                              hide-details="auto"
                              outlined
                              dense
                              single-line
                              required
                            ></v-text-field>
                          </td>
                          <td>
                            <v-btn
                              elevation="4"
                              class="ma-2"
                              outlined
                              color="error"
                              title="ลบข้อมูล"
                              height="45"
                              small
                              style="border-radius: 10px"
                              @click="deleteProductTable(index)"
                            >
                              <v-icon>mdi-trash-can-outline</v-icon>
                            </v-btn>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-col>
                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                  <div class="title_page ma-3" style="justify-content: center">
                    <v-btn
                      type="submit"
                      class="btn_add_data"
                      elevation="4"
                      large
                      >ส่งแบบฟอร์มโอน</v-btn
                    >
                  </div>
                </v-col>
              </v-row>
            </v-form>
          </div>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import { HTTP_ARIN } from "@/axios_arin";
import Swal from "sweetalert2";

export default {
  inject: {
    theme: {
      default: {
        isDark: false,
      },
    },
  },
  name: "transfer_goodsadd",
  data() {
    return {
      loading_page: false,
      branch_select: "",
      branch_option: "",
      productTalble: "",
      productList: [],
      productSelect: "",
      productTable: [], // เก็บข้อมูลสินค้าที่เลือก
      qty: 0,
      sub_menu: [
        {
          text: "ระบบ POS",
          disabled: false,
        },
        {
          text: "คลังสินค้า",
          disabled: false,
        },
        {
          text: "โอนสินค้า",
          disabled: false,
          // href: "/arin/pos/transfergoods",
        },
        {
          text: "สร้างรอบโอนสินค้า",
          disabled: false,
          href: "#",
        },
      ],
      order: ["ไทย", "จีน"],
      create_id:1
    };
  },
  methods: {
    getTransferAll() {
      this.loading_page = false;
      this.data_list = [];
      // const data = {
      //   page: this.page,
      //   size: this.size,
      // };
      // const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
      // HTTP_ARIN.post('/warehouse/transferall',data, config).then((res) => {
      //   if (res.data.successful === true) {
      //     this.loading_page = false;
      //     this.count_page = res.data.count_page;
      //     this.data_list = res.data.TransferAll;
      //   }
      // })
    },

    async getBranchAll() {
      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };
      await HTTP_ARIN.get("/warehouse/branchall", config).then((res) => {
        if (res.data.successful === true) {
          this.branch_option = res.data.branchtList.filter(el=>el.id!=this.$store.state.store_arin.user_data.store_id);
          this.loading_page = false;
        }
      });
    },

    async showProductAll() {
      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };
      await HTTP_ARIN.get("/warehouse/productall", config).then((res) => {
        if (res.data.successful === true) {
          this.productList = res.data.productList; // รายการสินค้าที่จะโอน
          this.loading_page = false;
        }
      });
    },

    addProductToTable() {
      // ตรวจสอบว่าสินค้าที่เลือกมีอยู่ใน productTable แล้วหรือยัง
      const isProductAlreadyAdded = this.productTable.some(
        (product) => product.id === this.productSelect
      );

      if (isProductAlreadyAdded) {
        this.$toast.error("สินค้านี้ถูกเพิ่มไปแล้ว");
        return; // ถ้ามีสินค้าอยู่แล้วให้ return ไม่ต้องเพิ่มซ้ำ
      }

      const selectedProduct = this.productList.find(
        (product) => product.id === this.productSelect
      );
      if (selectedProduct) {
        this.productTable.push({
          ...selectedProduct,
          qty: this.qty,
          create_id:this.create_id
        });
        this.productSelect = "";
        this.qty = 0;
        this.create_id++
      }
    },

    deleteProductTable(index) {
      this.productTable.splice(index, 1); // ลบข้อมูลจาก table
    },

    validateQty() {
      // if(inStock < 0){
      //   return true
      // }
      // else if (value > inStock) {
      //   return `จำนวนสินค้าไม่ควรเกิน ${inStock}`;
      // }
      return true;
    },
    addProductTransferStore() {
      if (this.$refs.form.validate()) {
        const selectedBranch = this.branch_option.find(
          (branch) => branch.customer_code === this.branch_select
        );

        const data = {
          branch_code: this.branch_select,
          branch_id: selectedBranch.id,
          branch_name: selectedBranch.store_name,
          product_list: this.productTable,
        };

        const config = {
          headers: {
            Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
          },
        };
        HTTP_ARIN.post("/warehouse/addtransferproduct", data, config).then(
          (res) => {
            if (res.data.successful === true) {
              let timerInterval;
              Swal.fire({
                title: "เสร็จสิ้น",
                text: "เพิ่มข้อมูลเรียบร้อย",
                icon: "success",
                timer: 2000,
                timerProgressBar: true,
                didOpen: () => {
                  Swal.showLoading();
                  timerInterval = setInterval(() => {});
                },
                willClose: () => {
                  clearInterval(timerInterval);
                  setTimeout(function () {
                    window.location.href = "/arin/pos/transfergoods";
                  });
                },
              });
            }
          }
        );
      }
    },
  },
  created() {},
  mounted() {
    this.showProductAll();
    this.getBranchAll();
    this.getTransferAll();
  },
};
</script>

<style scoped>
.title_form_main {
  background: #d6bfaf;
  z-index: 2;
  border-radius: 50%;
  box-shadow: 0px 2px 1px -1px rgb(0 0 0 / 20%),
    0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%);
  height: 38px;
  left: calc(50% - 19px);
  width: 38px;
}

.btn_add_data {
  font-size: 16px;
  color: #fff;
  background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%),
    #88b358 !important;
  border-radius: 10px;
  width: 15%;
}
</style>
